export default __webpack_public_path__ + "static/media/S-028.83bee6f0.png";